import React, { useState, useEffect } from 'react';
import { token, BASEAPIURL } from '../../env';
import CourtsManagement from './sportscourt';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';



const ITEM_HEIGHT = 60;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const daysOfWeek = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

function getStyles(name, personName, theme) {
  return {
    fontWeight: personName.includes(name)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}

const SportsSlot = ({showForm,setShowForm}) => {
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // const [showSlot, setShowSlot] = useState(false)
  // Form & Modal
  // const [showForm, setShowForm] = useState(false);
  // const [showFormCourts, setShowFormCourts] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [courts, setCourts] = useState([]);
  const [loadingCourts, setLoadingCourts] = useState(false);

  const TOKEN_DATA = token;

  const [currentSlot, setCurrentSlot] = useState({
    SlotName: '',
    Duration: '',
    startTime:'',
    endTime:'',
    CourtID: '',
    FacilityID: '',
    MemberPrice: '',
    GuestPrice: '',
    BookingAllowed: 'Yes',
    PlayerAllowed: '4',
    TaxIsInclude: false,
    IsEachPerson: false,
    TaxPercentage: 0,
    Discountper: 0,
    SlotDays: [],
    IsActive: true,
  });

    const [currentCourt, setCurrentCourt] = useState({
      CourtID: null,
      CourtName: '',
      CourtDes: '',
      Location: '',
      FacilityID: '',
      IsActive: true,
    });

  const theme = useTheme();

  // Fetch Slots on Mount
  useEffect(() => {
    fetchSlots();
    fetchCourts();
  }, []);

  const fetchSlots = async () => {
    setLoading(true);
    setError(null);
    try {
      const url = `${BASEAPIURL}/GetFacilitySlotList?Token=${encodeURIComponent(TOKEN_DATA)}`;
      const response = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const result = await response.json();
      if (result.status) {
        setSlots(result.data);
      } else {
        setError(result.error || 'Failed to load slots');
      }
    } catch (err) {
      setError(err.message || 'Network error');
    } finally {
      setLoading(false);
    }
  };

  const fetchCourts = async () => {
    setLoadingCourts(true);
    try {
      const response = await fetch(`${BASEAPIURL}/GetFacilityCourts?Token=${encodeURIComponent(token)}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const result = await response.text();
      console.log('Raw GetCourts Response:', result);

      let courtsData;
      try {
        courtsData = JSON.parse(result);
      } catch (e) {
        console.error('Invalid JSON from GetCourts', e);
        alert('Failed to parse court data. Check console.');
        return;
      }

      if (courtsData.status === true && Array.isArray(courtsData.data)) {
        setCourts(courtsData.data);
      } else {
        console.error('API Error:', courtsData.error || 'Unknown error');
        setCourts([]);
      }
    } catch (err) {
      console.error('Fetch Courts Error:', err);
      alert('Could not load courts. Network or API issue.');
      setCourts([]);
    } finally {
      setLoadingCourts(false);
    }
  };

  // Handle Input Change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setCurrentSlot((prev) => {
      const updatedSlot = {
        ...prev,
        [name]: type === 'checkbox' ? checked : value,
      };

      // If CourtID changes, update FacilityID
      if (name === 'CourtID') {
        const selectedCourt = courts.find((court) => court.CourtID === parseInt(value));
        updatedSlot.FacilityID = selectedCourt ? selectedCourt.FacilityID : '';
      }

      return updatedSlot;
    });
  };

  // Open Add Form
  const handleAdd = () => {
    setCurrentSlot({
      SlotName: '',
      Duration: '',
      startTime:'',
      endTime:'',
      CourtID: '',
      FacilityID: '',
      MemberPrice: '',
      GuestPrice: '',
      BookingAllowed: 'Yes',
      PlayerAllowed: '4',
      TaxIsInclude: false,
      IsEachPerson: false,
      TaxPercentage: 0,
      Discountper: 0,
      SlotDays: [],
      IsActive: true,
    });
    setIsEditing(false);
    setShowForm(true);
  };

  //  const handleAddCourt = () => {
  //     setCurrentCourt({
  //       CourtName: '',
  //       CourtDes: '',
  //       Location: '',
  //       FacilityID: '',
  //       IsActive: true,
  //     });
  //     // setIsEditing(false);
  //     setShowFormCourts(true);
  //   };

  // Update the handleEdit function to include SlotID and FacilityID
  const handleEdit = (slot) => {
    
    const selectedCourt = courts.find((court) => court.CourtID === slot.CourtID);
    setCurrentSlot({
      SlotName: slot.SlotName || '',
      startTime:slot.StartTime,
      endTime:slot.EndTime,
      // Duration: slot.Duration || '',
      CourtID: slot.CourtID || '',
      FacilityID: selectedCourt ? selectedCourt.FacilityID : slot.FacilityID || '',
      MemberPrice: slot.MemberPrice || '',
      GuestPrice: slot.GuestPrice || '',
      BookingAllowed: slot.BookingAllowed || 'Yes',
      PlayerAllowed: slot.PlayerAllowed || '4',
      TaxIsInclude: slot.TaxIsInclude || false,
      IsEachPerson: slot.IsEachPerson || false,
      TaxPercentage: slot.TaxPercentage || 0,
      Discountper: slot.Discountper || 0,
      SlotDays: slot.SlotDays || [],
      IsActive: slot.IsActive ?? true,
      SlotID: slot.SlotID,
    });
    setIsEditing(true);
    setShowForm(true);
  };

 
  
  // Submit Add/Edit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!currentSlot.SlotName?.trim()  || !currentSlot.CourtID) {
      alert('Slot Name, Duration, and Court are required.');
      return;
    }

    setIsSaving(true);

    const slotPayload = {
      SlotName: currentSlot.SlotName,
      startTime: isEditing ?currentSlot.startTime : `${currentSlot.startTime}:00`,
      endTime: isEditing ? currentSlot.endTime : `${currentSlot.endTime}:00`,
      // Duration: currentSlot.Duration,
      CourtID: parseInt(currentSlot.CourtID) || null,
      FacilityID: parseInt(currentSlot.FacilityID) || 0,
      MemberPrice: parseFloat(currentSlot.MemberPrice) || 0,
      GuestPrice: parseFloat(currentSlot.GuestPrice) || 0,
      BookingAllowed: currentSlot.BookingAllowed,
      PlayerAllowed: currentSlot.PlayerAllowed,
      TaxIsInclude: currentSlot.TaxIsInclude,
      IsEachPerson: currentSlot.IsEachPerson,
      TaxPercentage: parseFloat(currentSlot.TaxPercentage) || 0,
      Discountper: parseFloat(currentSlot.Discountper) || 0,
      SlotDays: currentSlot.SlotDays || [],
      IsActive: currentSlot.IsActive,
    };

    try {
      let response;
      if (isEditing) {
        const updatePayload = {
          tokenData: token,
          SlotID: currentSlot.SlotID,
          Slot: slotPayload,
        };

        response = await fetch(`${BASEAPIURL}/UpdateFacilitySlot?SlotID=${currentSlot.SlotID}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(updatePayload),
        });
      } else {
        const payload = {
          tokenData: token,
          Slot: slotPayload,
        };

        response = await fetch(`${BASEAPIURL}/InsertFacilitySlot`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
      }

      const result = await response.json();
      console.log('API Response:', result);

      if (result.data) {
        await fetchSlots();
        alert(`Slot ${isEditing ? 'updated' : 'added'} successfully!`);
        setShowForm(false);
      } else {
        throw new Error(result.error || 'Action failed');
      }
    } catch (err) {
      console.error('Save Error:', err);
      alert(`Failed to ${isEditing ? 'update' : 'add'} slot: ${err.message}`);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="p-3">
      {/* Header */}
      {/* <div className="d-flex justify-content-between align-items-center mb-4">
        <div className='bg-light border'>
          <button className={` ${!showSlot && 'bg-transparent'}`} onClick={() => setShowSlot(false)}><h5 className='text-black'>🎾 Courts Management</h5></button>
          <button className={` ${showSlot && 'bg-transparent'}`} onClick={() => setShowSlot(true)}><h5 className="text-dark" >🏸 Facility Time Slots</h5></button>
        </div>
        {showSlot ?<button className="btn btn-success px-4" onClick={handleAdd}>
          <i className="bi bi-plus-circle me-2"></i>Add Slot
        </button>: <button className="btn btn-success" onClick={handleAddCourt}>
          ➕ Add Court
        </button>}
      </div> */}
      

      {/* Table */}
    {slots.length === 0 ? (
        <div className="alert alert-info text-center">📭 No slots available.</div>
      ) : (
        <div className="table-responsive">
          <table className="table table-hover align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Duration</th>
                {/* <th>Court ID</th>
                <th>Facility ID</th>*/} 
                <th>Players</th>
                <th>Member (₹)</th>
                <th>Guest (₹)</th>
                <th>Booking</th>
                <th>Tax</th>
                <th>Each Person</th>
                <th>Tax %</th>
                <th>Dis %</th>
                <th>Slot Days</th>
                <th>Status</th>
                <th className="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {slots.map((slot, index) => (
                <tr key={slot.SlotID}>
                  <td>{index + 1}</td>
                  <td><strong>{slot.SlotName}</strong></td>
                  <td>
                    <span className="badge bg-primary bg-opacity-10 text-primary px-3 py-2 rounded-pill">
                      {slot.Duration}
                    </span>
                  </td>
                  {/* <td><code>{slot.CourtID}</code></td>
                  <td><code>{slot.FacilityID}</code></td> */}
                  <td><strong className="text-success">{slot.PlayerAllowed}</strong></td>
                  <td>{slot.MemberPrice ? `₹${slot.MemberPrice}` : '—'}</td>
                  <td>{slot.GuestPrice ? `₹${slot.GuestPrice}` : '—'}</td>
                  <td>
                    {slot.BookingAllowed === 'Yes'
                      ? <span className="badge text-bg-success">Yes</span>
                      : <span className="badge text-bg-danger">No</span>}
                  </td>
                  <td>
                    {slot.TaxIsInclude
                      ? <span className="badge text-bg-success">Included</span>
                      : <span className="badge text-bg-warning">Excluded</span>}
                  </td>
                  <td>
                    {slot.IsEachPerson
                      ? <span className="badge text-bg-success">Yes</span>
                      : <span className="badge text-bg-warning">No</span>}
                  </td>
                  <td>{slot.TaxPercentage ? `${slot.TaxPercentage}%` : '—'}</td>
                  <td>{slot.Discountper ? `${slot.Discountper}%` : '—'}</td>
                  <td>{slot.SlotDays ? `...${slot.SlotDays}` : '—'}</td>
                  <td>
                    {slot.IsActive
                      ? <span className="badge text-bg-success">Active</span>
                      : <span className="badge text-bg-secondary">Inactive</span>}
                  </td>
                  <td className="text-center">
                    <button
                      className="btn btn-sm btn-outline-primary me-2"
                      onClick={() => handleEdit(slot)}
                    >
                      ✏️ Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {/* // <CourtsManagement showFormCourts={showFormCourts} setShowFormCourts={setShowFormCourts} /> */}
     

      {/* Add/Edit Modal */}
      {showForm && (
        <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex="-1">
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <form onSubmit={handleSubmit}>
                <div className="modal-header">
                  <h5 className="modal-title">{isEditing ? '✏️ Edit Slot' : '➕ Add New Slot'}</h5>
                  <button type="button" className="btn-close" onClick={() => setShowForm(false)}></button>
                </div>

                <div className="modal-body">
                  <div className='row'>
                    <div className="mb-3 col-5">
                      <label className="form-label">Slot Name *</label>
                      <input
                        type="text"
                        className="form-control py-1"
                        name="SlotName"
                        value={currentSlot.SlotName}
                        onChange={handleChange}
                        placeholder="e.g. Morning Slot"
                        required
                      />
                    </div>
                    <div className="mb-3 col-5 offset-1">
                      <label className="form-label">Select Court *</label>
                      {loadingCourts ? (
                        <div className="form-control text-muted">Loading courts...</div>
                      ) : courts.length === 0 ? (
                        <div className="form-control text-danger">No courts found</div>
                      ) : (
                        <select
                          className="form-control py-1"
                          name="CourtID"
                          value={currentSlot.CourtID || ''}
                          onChange={handleChange}
                          required
                        >
                          <option value="">-- Select a Court --</option>
                          {courts.map((court) => (
                            <option key={court.CourtID} value={court.CourtID}>
                              🏟️ {court.CourtName} | {court.FacilityName} | ID: {court.CourtID}
                            </option>
                          ))}
                        </select>
                      )}
                    </div>
                  </div>
                  <div className='row'>
                    <div className="mb-3 col-5">
                      <label className="form-label">Start Duration *</label>
                       <input
                      type="time"
                      className="form-control"
                      name="startTime"
                      value={currentSlot.startTime}
                      onChange={handleChange}
                      placeholder=" 09:00 PM"
                      required
                    />
                    
                    </div>
                    <div className="mb-3 col-5 offset-1">
                      <label className="form-label">End Duration *</label>
                         <input
                      type="time"
                      className="form-control"
                      name="endTime"
                      value={currentSlot.endTime}
                      onChange={handleChange}
                      placeholder=" 09:00 PM"
                      required
                    />
                    
                    </div>
                  </div>
                  <div className='row'>
                    <div className="mb-3 col-5">
                      <label className="form-label">Facility ID</label>
                      <input
                        type="text"
                        className="form-control py-1"
                        name="FacilityID"
                        value={currentSlot.FacilityID}
                        readOnly
                      />
                    </div>
                    <div className="mb-3 col-5 offset-1">
                      <label className="form-label">Players Allowed</label>
                      <input
                        type="number"
                        className="form-control py-1"
                        name="PlayerAllowed"
                        value={currentSlot.PlayerAllowed}
                        onChange={handleChange}
                        min="2"
                        max="23"
                      />
                    </div>
                  </div>
                  <div className='row'>
                    <div className="mb-3 col-5">
                      <label className="form-label">Member Price (₹)</label>
                      <input
                        type="number"
                        step="0.01"
                        className="form-control py-1"
                        name="MemberPrice"
                        value={currentSlot.MemberPrice}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="mb-3 col-5 offset-1">
                      <label className="form-label">Guest Price (₹)</label>
                      <input
                        type="number"
                        step="0.01"
                        className="form-control py-1"
                        name="GuestPrice"
                        value={currentSlot.GuestPrice}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className='row'>
                    <div className="mb-3 col-5">
                      <label className="form-label">Tax Percentage (%)</label>
                      <input
                        type="number"
                        className="form-control py-1"
                        name="TaxPercentage"
                        value={currentSlot.TaxPercentage}
                        onChange={handleChange}
                        min="0"
                        max="100"
                        step="0.01"
                      />
                    </div>
                    <div className="mb-3 col-5 offset-1">
                      <label className="form-label">Discount Percentage (%)</label>
                      <input
                        type="number"
                        className="form-control py-1"
                        name="Discountper"
                        value={currentSlot.Discountper}
                        onChange={handleChange}
                        min="0"
                        max="100"
                        step="0.01"
                      />
                    </div>
                  </div>
                  <div className='row'>
                    <div className="mb-3 col-5">
                      <label className="form-label">Slot Days</label>
                      <FormControl className="form-control" >
                        <Select
                          multiple
                          displayEmpty
                          className='py-1'
                          name="SlotDays"
                          value={currentSlot.SlotDays}
                          onChange={handleChange}
                          input={<OutlinedInput />}
                          sx={{
                            '& .MuiSelect-select': { paddingY: '1px' }
                          }}
                          renderValue={(selected) => (
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                              {
                                selected.length === 0 ?
                                  <em>Select a days</em> :
                                  selected.map((value) => (
                                    <Chip key={value} label={value} />
                                  ))}
                            </Box>
                          )}
                          MenuProps={MenuProps}
                        >
                          {daysOfWeek.map((name) => (
                            <MenuItem
                              key={name}
                              value={name}
                              style={getStyles(name, currentSlot.SlotDays, theme)}
                            >
                              {name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>


                    </div>
                  </div>
                  <div className='row ms-1'>
                    <div className="form-check form-switch mb-3 col-6">
                      <input
                        type="checkbox"
                        id="BookingAllowed"
                        role='switch'
                        className="form-check-input px-4"
                        name="BookingAllowed"
                        checked={currentSlot.BookingAllowed === 'Yes'}
                        onChange={(e) =>
                          setCurrentSlot((prev) => ({
                            ...prev,
                            BookingAllowed: e.target.checked ? 'Yes' : 'No',
                          }))
                        }
                      />
                      <label htmlFor="BookingAllowed" className="form-check-label ms-2">
                        Allow Booking
                      </label>
                    </div>
                    <div className="form-check form-switch mb-3 col-6">
                      <input
                        type="checkbox"
                        id="TaxIsInclude"
                        className="form-check-input px-4"
                        name="TaxIsInclude"
                        checked={currentSlot.TaxIsInclude}
                        onChange={handleChange}
                      />
                      <label htmlFor="TaxIsInclude" className="form-check-label ms-2">
                        Tax Included in Price
                      </label>
                    </div>
                  </div>
                  <div className='row ms-1'>
                    <div className="form-check form-switch mb-3 col-6">
                      <input
                        type="checkbox"
                        role="switch"
                        id="IsEachPerson"
                        className="form-check-input px-4"
                        name="IsEachPerson"
                        checked={currentSlot.IsEachPerson}
                        onChange={handleChange}
                      />
                      <label htmlFor="IsEachPerson" className="form-check-label ms-2">
                        Price Per Person
                      </label>
                    </div>

                    <div className="form-check form-switch mb-3 col-6">
                      <input
                        type="checkbox"
                        id="IsActive"
                        className="form-check-input px-4"
                        name="IsActive"
                        checked={currentSlot.IsActive}
                        onChange={handleChange}
                      />
                      <label htmlFor="IsActive" className="form-check-label ms-2">
                        Active
                      </label>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowForm(false)}
                    disabled={isSaving}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary" disabled={isSaving}>
                    {isSaving ? 'Saving...' : isEditing ? '💾 Update Slot' : '✅ Add Slot'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* Backdrop */}
      {showForm && <div className="modal-backdrop fade show"></div>}
      {showForm && <div className="modal-open"></div>}


    </div>
  );
};

export default SportsSlot;